import http from '../_http'

const system = {
  //default
  summarySys: (m) => { return http.get(`manager/log/system`, m); },
  listSys: (m) => { return http.post(`manager/log/system/list`, m); },
  detailSys: (m) => { return http.get(`manager/log/system/${m.id}`, m); },
}

export default system

export { system }